<template>
  <Title :data="articleData" />
  <div class="dp">
    <Date :data="articleData" />
    <Source :data="articleData" />
  </div>
  <ShareBtns
    :data="articleData"
    v-if="
      articleData.nodeName == '國際趨勢' ||
      articleData.nodeName == '公布欄' ||
      articleData.nodeName == '職場資訊'
    "
  />
  <Content :data="articleData" />
  <DownloadAndWebUrl
    :relatedLink="relatedLink"
    :downloadFiles="downloadFiles"
  />
  <FurtherReading
    v-if="relatedData.keywords.length"
    :keywords="relatedData.keywords"
    :items="relatedData.items"
  />
</template>

<script setup>
import Title from "@/components/Title.vue";
import ShareBtns from "@/components/ShareBtns.vue";
import Date from "@/components/Date.vue";
import Content from "@/components/Content.vue";
import Source from "@/components/Source.vue";
import DownloadAndWebUrl from "@/components/DownloadAndWebUrl.vue";
import FurtherReading from "@/components/FurtherReading.vue";
import { useRoute } from "vue-router";
import { reactive, watch } from "vue";
import { getArticleDataAPI } from "@/api/api.js";

const route = useRoute();
const pageId = route.params.pageId;

const articleData = reactive({
  nodeName: "",
  pageTitle: "",
  pageContent: "",
  imageFiles: [],
  videoFiles: [],
  pagePublishUp: "",
  source: "",
  posterName: "",
  imageType: 1,
  url:window.location.href
});

const relatedData = reactive({
  keywords: [],
  items: [],
});

getArticleDataAPI(pageId)
  .then((res) => {
    setData(res.data);
  })
  .catch(function (res) {
    console.log(res);
  });

const setData = (data) => {
  setArticleData(data);
  setFurtherReadingData(data);
  setRelatedLink(data);
  // setMeta();
  if (data.uploadFiles) downloadFiles.push(...data.uploadFiles);
};

const setArticleData = (data) => {
  articleData.source = data.source;
  articleData.nodeName = data.nodeName;
  articleData.pageTitle = data.pageTitle;
  articleData.pageContent = data.pageContent;
  articleData.pagePublishUp = data.pagePublishUp;
  articleData.imageFiles = data.imageFiles;
  articleData.posterName = data.posterName ? data.posterName : "";
  articleData.videoFiles = data.videoFiles ? data.videoFiles : [];
  articleData.imageType = data.imageType ? data.imageType : 1;
};

const setMeta = () => {
  var metaOgTitle = document.querySelector('meta[property="og:title"]');
  metaOgTitle.content = articleData.pageTitle;
  var metaOgDes = document.querySelector('meta[property="og:description"]');
  metaOgDes.content = articleData.pageContent;
  var metaOgImage = document.querySelector('meta[property="og:image"]');
  if (articleData.imageFiles != null && articleData.imageFiles.length != 0) {
    metaOgImage.content = articleData.imageFiles[0].filePath;
  }
  var metaOgUrl = document.querySelector('meta[property="og:url"]');
  metaOgUrl.content = window.location.href;
  var metaList = document.getElementsByTagName("meta");
  for (var i = 0; i < metaList.length; i++) {
    if (metaList[i].getAttribute("name") == "twitter:title") {
      metaList[i].content = articleData.pageTitle;
    } else if (metaList[i].getAttribute("name") == "twitter:image") {
      if (
        articleData.imageFiles != null &&
        articleData.imageFiles.length != 0
      ) {
        metaList[i].content = articleData.imageFiles[0].filePath;
      }
    } else if (metaList[i].getAttribute("name") == "twitter:description") {
      metaList[i].content = articleData.pageContent;
    } else if (metaList[i].getAttribute("name") == "twitter:url") {
      metaList[i].content = window.location.href;
    }
  }
};

const setFurtherReadingData = (data) => {
  relatedData.keywords = data.keywords ? data.keywords : [];
  relatedData.items = data.furtherReads ? data.furtherReads : [];
};

const downloadFiles = reactive([]);
const relatedLink = reactive({
  url: "",
  name: "",
});

const setRelatedLink = ({ pageUrl, pageUrlName }) => {
  relatedLink.url = pageUrl ? pageUrl : "";
  relatedLink.name = pageUrlName ? pageUrlName : "";
};

watch(
  () => route.params.pageId,
  (currentPageId) => {
    getArticleDataAPI(currentPageId).then((res) => {
      setData(res.data);
    });
  }
);
</script>

<style lang="scss" scoped>
.dp {
  display: flex;
  padding: 10px 0;
}
</style>
